import React from "react";

import { useFormikContext } from "formik";

import { Typography, Button, Pane } from "clearsense-ui/components";
import {
  Select,
  Input,
  DatePicker,
} from "components/Common/clearsense-ui/components/formik";
import convertToSelectOptions from "utils/convertToSelectOptions";

import { SURVIVORSHIP_DOMAIN_SOURCE_NAMES } from "../../../constants";

const BusinessRulePane = ({
  approvers,
  cdes,
  domains,
  isShowPane,
  isEdit,
  isFilterLoading,
  setIsShowPane,
  setEditRecord,
}) => {
  const formik = useFormikContext();

  return (
    <Pane
      isOpen={isShowPane}
      onClose={() => {
        setEditRecord({});
        setIsShowPane(false);
      }}
    >
      <Pane.Header>
        <Typography type="semibold" style="h3">
          {isEdit ? "Edit" : "Add New "} Business Rule
        </Typography>
      </Pane.Header>
      <Pane.Body className="space-y-4 py-4">
        <Input
          required
          name="rule_no"
          label="Business Rule Number"
          placeholder="Enter the Business Rule Number"
          size="large"
          className="w-full"
        />
        <Input
          required
          name="rule"
          label="Business Rule"
          placeholder="Enter the Business Rule"
          size="large"
          className="w-full"
        />
        <Select
          required
          isClearable
          name="context"
          label="Context"
          placeholder="Select the Context"
          className="w-full"
          options={convertToSelectOptions(["Enterprise"], { isSort: true })}
        />
        <Input
          required
          name="ruleType"
          label="Business Rule Type"
          placeholder="Enter the Business Rule Type"
          size="large"
          className="w-full"
        />
        <Select
          isClearable
          name="sourceName"
          label="Source Name"
          placeholder="Select the Source Name"
          className="w-full"
          options={convertToSelectOptions(SURVIVORSHIP_DOMAIN_SOURCE_NAMES, {
            isSort: true,
          })}
        />
        <Input
          required
          name="ruleCategory"
          label="Business Rule Category"
          placeholder="Enter the Business Rule Category"
          size="large"
          className="w-full"
        />
        <Select
          required
          isClearable
          name="domain"
          label="Domain"
          placeholder="Select the Domain"
          className="w-full"
          options={convertToSelectOptions(domains, { isSort: true })}
          isLoading={isFilterLoading}
        />
        <Select
          required
          isClearable
          name="cde"
          label="Critical Data Element"
          placeholder="Select the CDE"
          className="w-full"
          options={convertToSelectOptions(cdes, { isSort: true })}
          isLoading={isFilterLoading}
        />
        <Select
          required
          name="approver"
          label="Approver"
          placeholder="Select the Approver"
          className="w-full"
          options={convertToSelectOptions(approvers, { isSort: true })}
          isLoading={isFilterLoading}
        />
        <DatePicker
          name="approvalDate"
          label="Approval Date*"
          placeholder="Select the Approval Date"
          size="large"
          dateFormat="YYYY-MM-DD"
          className="w-full"
        />
      </Pane.Body>
      <Pane.Footer className="space-x-2">
        <Button
          label={isEdit ? "Save" : "Add"}
          type="submit"
          size="medium"
          loading={formik.isSubmitting}
          disabled={!formik.dirty}
          onClick={() => formik.submitForm()}
        />
        <Button
          style="secondary"
          label="Cancel"
          size="medium"
          onClick={() => {
            setIsShowPane(false);
            setEditRecord({});
            formik.resetForm();
          }}
        />
      </Pane.Footer>
    </Pane>
  );
};

export default BusinessRulePane;
